import { ROWS } from "@/lib/contracts";
import { fmtTL } from "@/lib/utils";
import { cn } from "@/lib/utils";

export function PaymentReport({ calc, compact }) {
  return (
    <div className="rounded-lg border border-border overflow-hidden" data-testid="payment-report">
      {ROWS.map(([k, label, bold]) => (
        <div key={k} className={cn("flex items-center gap-3 px-3 border-b border-border last:border-0", compact ? "py-1 text-xs" : "py-1.5 text-sm",
          bold && "bg-muted/40 font-semibold", k === "R" && "bg-amber-500/15 text-amber-800 dark:text-amber-300 text-base")} data-testid={`calc-${k}`}>
          <span className="w-7 text-muted-foreground font-mono">{k}</span>
          <span className="flex-1">{label}</span>
          <span className="font-mono-nums">{fmtTL(calc[k])}</span>
        </div>
      ))}
    </div>
  );
}
